// ─── Meta template approval states ───
// Only relevant on the Official WhatsApp API: every message must go out as a
// template Meta has reviewed, so each one carries an approval status.
export type MetaTemplateStatusStyle = { label: string; color: string; bg: string; hint: string };

export const TEMPLATE_STATUS_STYLES: Record<string, MetaTemplateStatusStyle> = {
  APPROVED: { label: 'Approved', color: '#22c55e', bg: '#22c55e22', hint: 'Meta approved this template — it can be sent.' },
  PENDING: { label: 'In review', color: '#ed8936', bg: '#ed893622', hint: 'Meta is reviewing this template. It cannot be sent until approved.' },
  REJECTED: { label: 'Rejected', color: '#ef4444', bg: '#ef444422', hint: 'Meta rejected this template. Edit the message and save again.' },
  PAUSED: { label: 'Paused', color: '#ef4444', bg: '#ef444422', hint: 'Meta paused this template because of poor recipient feedback.' },
  DISABLED: { label: 'Disabled', color: '#ef4444', bg: '#ef444422', hint: 'Meta disabled this template. It can no longer be sent.' },
  PENDING_DELETION: { label: 'Deleting', color: 'var(--color-text-faint)', bg: 'var(--color-bg)', hint: 'This template is being removed at Meta.' },
  IN_APPEAL: { label: 'In appeal', color: '#3b82f6', bg: '#3b82f622', hint: 'A rejection is being appealed with Meta.' },
};

export function templateStatusStyle(status: string): MetaTemplateStatusStyle {
  return (
    TEMPLATE_STATUS_STYLES[status.toUpperCase()] || {
      label: status,
      color: 'var(--color-text-subtle)',
      bg: 'var(--color-bg)',
      hint: `Meta reports this template as ${status}.`,
    }
  );
}

/** Style for a Campaigns message template: unsynced rows read as not submitted. */
export function messageTemplateStatusStyle(template: {
  Status?: string | null;
  MetaSynced?: boolean;
}): MetaTemplateStatusStyle {
  if (!template.MetaSynced || !template.Status) {
    return {
      label: 'Not submitted',
      color: '#94a3b8',
      bg: '#94a3b822',
      hint: 'Not submitted to Meta yet. Edit and save this template to submit it.',
    };
  }
  return templateStatusStyle(template.Status);
}

/** True when a Campaigns message template can be sent on the Official API. */
export function messageTemplateSendable(template: { Status?: string | null; MetaSynced?: boolean }): boolean {
  return !!template.MetaSynced && (template.Status || '').toUpperCase() === 'APPROVED';
}
